import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createBoard } from "../../api/boardManage";
import { fetchBoardListAsync } from "../../store/boardSlice";
import { AppDispatch } from "../../store";
import { setLocalStorage } from "../../util/storage";
import { useMatomoTrackingPoint } from "../../hooks/useMatomoTrackingPoint";
import {CreateIcon, MobileNavIcon, ProjectListIcon} from "../../icons";
import { useState } from "react";

export default function MobileNavigation() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();
    const isHome = location.pathname.includes('home');
    const [createLoading, setCreateLoading] = useState(false);
    const {trackBoardSelectionPopupShow} = useMatomoTrackingPoint();

    const changeBoard = (boardId?: string, boardType?: "moodBoard" | "inspireBoard") => {
        setLocalStorage('boardId', boardId);
        const inspireQuery = boardType === 'inspireBoard' ? '&inspire=1' : '';
        navigate(`/?boardId=${boardId}${inspireQuery}`);
    }

    const createNewBoard = () => {
        if (createLoading) return
        setCreateLoading(true);
        createBoard({boardType: 'inspireBoard'}).then(item=>{
            changeBoard(item?.boardId, item?.boardType)
            setCreateLoading(false)
            dispatch(fetchBoardListAsync())
        })
    }

    return <div style={{
       height: '60px',
       backgroundColor: 'var(--c-bg)',
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
    }}>
        <div style={{cursor: 'pointer'}} onClick={() => navigate('/dashboard/home')}>
            <MobileNavIcon highlight={isHome} />
        </div>
        <div style={{cursor: 'pointer'}} onClick={() => {
            trackBoardSelectionPopupShow({board_selection_from: 'home_page'})
            createNewBoard()
        }}>
            <CreateIcon />
        </div>
        <div style={{cursor: 'pointer'}} onClick={() => navigate('/dashboard')}>
            <ProjectListIcon highlight={!isHome} />
        </div>
    </div>
}
